var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pay-situation-dowanload-container" }, [
    _c(
      "div",
      { staticClass: "content" },
      _vm._l(_vm.list, function(item, index) {
        return _c(
          "div",
          { key: index, staticClass: "card-wrapper" },
          [
            _c(
              "mobile-card",
              { attrs: { "show-title": false, "show-footer": true } },
              [
                _c("template", { slot: "content" }, [
                  _c("div", { staticClass: "flex-form-info" }, [
                    _c("span", [_vm._v("收费项目")]),
                    _c("span", [_vm._v(_vm._s(item.itemName))])
                  ]),
                  _c("div", { staticClass: "flex-form-info" }, [
                    _c("span", [_vm._v("交费金额")]),
                    _c("span", { staticClass: "money-item" }, [
                      _vm._v(_vm._s(_vm._f("formatMoney")(item.payMoney)))
                    ])
                  ]),
                  _c("div", { staticClass: "flex-form-info" }, [
                    _c("span", [_vm._v("交费日期")]),
                    _c("span", [_vm._v(_vm._s(item.payTime))])
                  ]),
                  _c("div", { staticClass: "flex-form-info" }, [
                    _c("span", [_vm._v("发票号码")]),
                    _c("span", [_vm._v(_vm._s(item.ticketNum))])
                  ])
                ]),
                _c("template", { slot: "footer" }, [
                  _c("div", { staticClass: "flex-form-footer" }, [
                    _c(
                      "a",
                      {
                        staticClass: "flex-form-btn",
                        attrs: { target: "_blank", href: item.url }
                      },
                      [_vm._v("下载发票")]
                    )
                  ])
                ])
              ],
              2
            )
          ],
          1
        )
      }),
      0
    ),
    _c("div", { staticClass: "footer" }, [
      _c(
        "div",
        { staticClass: "footer-bar" },
        [
          _c(
            "mobile-button",
            { attrs: { color: "#005423" }, on: { click: _vm.onBack } },
            [_vm._v("返回上一级")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }